import { BsCheckSquare } from "react-icons/bs";
import { GoLocation } from "react-icons/go";
import Moment from "react-moment";
import { formatNumber } from "../../../../utils/formatNumber";
import { Table } from "antd";
import LoadingIcon from "../../../../components/shared/LoadingIcon";

export default function WallBookings({ bookings, isLoading }: any) {
  let columns = [
    {
      title: "S/N",
      width: 50,
      dataIndex: "",
      render: (record: any, text: any, index: any) => (
        <span className="text-gray-700 ml-2">{index + 1}</span>
      ),
    },
    {
      title: "Customer",
      width: 150,
      dataIndex: "",
      render: (record: any) => (
        <div className="w-full">
          {record?.customer_code === 0 ? (
            <div className="text-gray-700 bg-red-200 px-2 py-1 w-full">
              <span className="mr-2"> Guest:</span>
              {record?.customer_name === null ? "-" : record?.customer_name}
            </div>
          ) : (
            <div className="px-2 py-1">
              {record?.customer_name === null ? "-" : record?.customer_name}
            </div>
          )}
        </div>
      ),
    },
    {
      title: "Requested",
      width: 90,
      dataIndex: "",
      render: (record: any) => (
        <span className="text-gray-700">
          {record?.createdAt === null ? (
            "-"
          ) : (
            <Moment fromNow>{record?.createdAt}</Moment>
          )}
        </span>
      ),
    },
    {
      title: "Vehicle",
      width: 80,
      dataIndex: "",
      render: (record: any) => (
        <div className="flex flex-col">
          <span className="text-gray-700">
            {record?.vehicle === null ? "-" : record?.vehicle}
          </span>
        </div>
      ),
    },
    {
      title: "Model",
      width: 100,
      dataIndex: "",
      render: (record: any) => (
        <span className="text-gray-700">
          {record?.model_year === null ? "" : record?.model_year}{" "}
          {record?.model === null ? "-" : record?.model}
        </span>
      ),
    },
    // {
    //   title: "Mileage",
    //   width: 100,
    //   dataIndex: "",
    //   render: (record: any) => (
    //     <div className="text-gray-700">
    //       {record?.mileage === null || record?.mileage === ""
    //         ? "-"
    //         : `${formatNumber(Number(record?.mileage))} Km`}
    //     </div>
    //   ),
    // },

    {
      title: "Date",
      width: 100,
      dataIndex: "",
      render: (record: any) => (
        <span className="text-gray-700">
          {record?.date === undefined || record?.date === null ? (
            "-"
          ) : (
            <>
              <Moment format="Do MMM, YYYY">{record?.date}</Moment>
            </>
          )}
        </span>
      ),
    },

    {
      title: "Time",
      width: 140,
      dataIndex: "",
      render: (record: any) => (
        <span className="text-gray-700">
          {record?.date === undefined || record?.date === null ? (
            "-"
          ) : (
            <>
              {record?.slottime === null ? (
                "-"
              ) : (
                <>
                  <Moment format="HH:mm A">
                    {record?.slottime?.starttime}
                  </Moment>
                  <span className="mx-1">-</span>
                  <Moment format="HH:mm A">{record?.slottime?.endtime}</Moment>
                </>
              )}
            </>
          )}
        </span>
      ),
    },
    {
      title: "Booking No.",
      width: 100,
      dataIndex: "",
      render: (record: any) => (
        <div className="flex justify-center items-center text-gray-700">
          <span className="ml-1">
            {record?.bookingno ? record?.bookingno : "-"}
          </span>
        </div>
      ),
    },
    {
      title: "WIP",
      width: 60,
      dataIndex: "",
      render: (record: any) => (
        <div className="flex justify-center items-center text-gray-700">
          <span className="">{record?.wip ? record?.wip : "-"}</span>
        </div>
      ),
    },

    {
      title: "Advisor",
      width: 100,
      dataIndex: "",
      render: (record: any) => (
        <div className="flex items-center text-gray-700">
          <div className="ml-1 trancate">
            {record?.assignedTo
              ? `${record?.assignedTo?.firstname.charAt(0)}.${
                  record?.assignedTo?.lastname
                }`
              : "-"}
          </div>
        </div>
      ),
    },

    {
      title: "Location",
      width: 120,
      dataIndex: "",
      render: (record: any) => (
        <div className="flex truncate">
          <div className="flex justify-center items-center ml-1 text-blue-700 border rounded-md px-2 py-1 bg-blue-50 hover:bg-blue-50">
            <GoLocation /> <span className="ml-1">-</span>
          </div>
        </div>
      ),
    },
    {
      title: "Status",
      width: 70,
      dataIndex: "",
      render: (record: any) => (
        <div className="flex">
          {record.is_confirmed ? (
            <div className="bg-status-green font-bold px-2 py-1 rounded-md text-center text-white w-full flex items-center justify-center">
              <BsCheckSquare /> <span className="ml-1">CONFIRMED</span>
            </div>
          ) : (
            <div className="bg-status-red text-white font-bold px-2 py-1 rounded-md text-center w-full">
              <span>UNCONFIRMED</span>
            </div>
          )}
        </div>
      ),
    },
  ];

  if (isLoading) {
    return (
      <div className="flex justify-center bg-white">
        <LoadingIcon />
      </div>
    );
  }
  return (
    <Table
      columns={columns}
      dataSource={bookings}
      size="small"
      pagination={false}
      rowKey="id"
      loading={isLoading}
    />
  );
}
